import React, { useEffect, useState } from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";
import api from "@/lib/api";
import { Card, PageHead } from "@/admin/ui";

const Stat = ({ label, value }) => (
  <Card className="text-center">
    <p className="font-serif text-5xl mb-1">{value}</p>
    <p className="overline text-espresso/50">{label}</p>
  </Card>
);

const Overview = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <p className="text-espresso/50">Loading…</p>;
  return (
    <div>
      <PageHead title="Overview" sub="Your world at a glance." />
      {d.readiness && (
        <Card className="mb-8" data-testid="go-live-readiness">
          <div className="flex items-center justify-between mb-4">
            <p className="overline text-espresso/50">Go-live readiness</p>
            <span className="text-xs text-espresso/50" data-testid="readiness-score">{d.readiness.filter((r) => r.ok).length}/{d.readiness.length} ready</span>
          </div>
          <ul className="space-y-2.5">
            {d.readiness.map((r) => (
              <li key={r.key} data-testid={`readiness-${r.key}`} className="flex items-start gap-3 text-sm">
                {r.ok ? <CheckCircle2 size={17} strokeWidth={1.6} className="text-sage shrink-0 mt-0.5" /> : <AlertCircle size={17} strokeWidth={1.6} className="text-wine shrink-0 mt-0.5" />}
                <span className="flex-1"><span className={r.ok ? "text-espresso/70" : "text-espresso"}>{r.label}</span> <span className="text-espresso/40">— {r.detail}</span></span>
              </li>
            ))}
          </ul>
        </Card>
      )}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <Stat label="Products" value={d.products} />
        <Stat label="Live" value={d.live} />
        <Stat label="Collections" value={d.collections} />
        <Stat label="Journal" value={d.journal} />
        <Stat label="Newsletter" value={d.newsletter} />
        <Stat label="Waitlist" value={d.waitlist} />
        <Stat label="Orders" value={d.orders} />
        <Stat label="Sales" value={`£${d.sales}`} />
        <Stat label="AOV" value={`£${d.aov ?? 0}`} />
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <Card>
          <p className="overline text-espresso/50 mb-4">Low Stock</p>
          {d.low_stock.length ? <ul className="text-sm space-y-1.5 text-espresso/70">{d.low_stock.map((s, i) => <li key={i}>{s}</li>)}</ul> : <p className="text-sm text-espresso/40">No low-stock variants.</p>}
        </Card>
        <Card>
          <p className="overline text-espresso/50 mb-4">Sold Out</p>
          {d.sold_out.length ? <ul className="text-sm space-y-1.5 text-espresso/70">{d.sold_out.map((s, i) => <li key={i}>{s}</li>)}</ul> : <p className="text-sm text-espresso/40">Nothing sold out.</p>}
        </Card>
      </div>
    </div>
  );
};

export default Overview;
